export default {
  faqTitle: 'Bereket Sigorta Hakkında Merak Edilen Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  products: {
    title: 'Bereket Sigorta Ürünleri',
    buttons: [
      {
        id: 1,
        title: 'KASKO SİGORTASI',
        class: 'company--btn--icons fas fa-car-crash fa-2x mr-2',
        path: 'BereketSigortaMotorInsurance'
      },
      {
        id: 2,
        title: 'TRAFİK SİGORTASI',
        class: 'company--btn--icons fas fa-car fa-2x mr-2',
        path: 'BereketSigortaCompulsoryTraffic'
      },
      {
        id: 3,
        title: 'KONUT SİGORTASI',
        class: 'company--btn--icons fas fa-house-damage fa-2x mr-2',
        path: 'BereketSigortaHomeInsurance'
      },
      {
        id: 4,
        title: 'DASK SİGORTA',
        class: 'company--btn--icons fas fa-laptop fa-2x mr-2',
        path: 'BereketSigortaDaskInsurance'
      },
      {
        id: 5,
        title: 'İŞYERİ SİGORTASI',
        class: 'company--btn--icons fas fa-building fa-2x mr-2',
        path: 'BereketSigortaCompanyInsurance'
      },
      {
        id: 6,
        title: 'FERDİ KAZA SİGORTASI',
        class: 'company--btn--icons fas fa-user-injured fa-2x mr-2',
        path: 'BereketSigortaPersonalAccident'
      },
      {
        id: 7,
        title: 'NAKLİYAT SİGORTASI',
        class: 'company--btn--icons fas fa-dolly-flatbed fa-2x mr-2',
        path: 'BereketSigortaTransportation'
      },
      {
        id: 8,
        title: 'SEYAHAT SAĞLIK SİGORTASI',
        class: 'company--btn--icons fas fa-umbrella-beach fa-2x mr-2',
        path: 'BereketSigortaTravelInsurance'
      }
    ]
  },
  introContent: {
    title: 'Bereket Sigorta Hakkında',
    content: [
      {
        paragraph:
          '1995 yılında kurulan Bereket Sigorta, 2017 yılında TMSF ‘den devralınarak, 157 senelik köklü geçmişi olan, 17 bölge noktası, 1619 kooperatifi ve yaklaşık 1,5 milyon çiftçi ortağı olan Türkiye Tarım Kredi Kooperatifleri ’ne devredildi. '
      },
      {
        paragraph:
          'Bereket Sigorta; Yangın, Trafik, Kasko, Mühendislik, Tarım, Sağlık, Ferdi Kaza, Nakliyat, Hukuksal Koruma, Oto Dışı Kaza, DASK ve Sorumluluk Sigortaları da dâhil tüm branşlarda hizmet göstermektedir. '
      },
      {
        paragraph:
          'Kurulduğu andan itibaren teknolojiyi en detaylı kullanan firmalar arasında yer almaktadır.'
      },
      {
        paragraph:
          'Türkiye’de 10 bölge müdürlüğü, 750’ye yakın acente ve Türkiye Finans Katılım Bankası, Anadolu bank, PTT Bank, Emlak Katılım Bankası be İller Bankası şubeleri satış kanalları olarak hizmet vermektedir. '
      },
      {
        paragraph:
          'Piyasanın ve müşterilerin ihtiyaçlarına uygun olan ürünleri oluşturmak ve acentelerin güvenebilecekleri, ticari yaşamları boyunca iş birliği yapılabilecek şirket olmak Bereket Sigorta’nın öncelikli hedefidir.'
      }
    ]
  },
  questions: [
    {
      title: 'Bereket Sigorta Ürün Çeşitleri Nelerdir?',
      content: [
        {
          paragraph:
            'Bereket Sigorta Alokasko’nun anlaşmalı olduğu sigorta şirketlerindendir. Şirketimiz bünyesinde size özel teklif verebileceğimiz bazı sigorta ürünleri;',
          subList: [
            'Trafik Sigortası',
            'Araç Kasko Sigortası',
            'DASK (Zorunlu Deprem Sigortası)',
            'Konut Sigortası',
            'İşyeri Sigortası',
            'Ferdi Kaza Sigortası',
            'Nakliyat Sigortası ',
            'Seyahat Sağlık Sigortası'
          ]
        },
        {
          paragraph:
            'Tüm bu branşlarda ihtiyaç duyduğunuz poliçelere sahip olabilirsiniz. Bereket Sigorta ile özel anlaşmalarımız gereği tarafınıza sunacağımız ekstra teminat ve çok uygun rakamları hemen değerlendirebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Bereket Sigorta ürünleri kapsamında hizmet almak isteyen müşterilerimiz <strong><em><u>alokasko.com</u></em></strong> üzerinden teklif formunu doldurabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Zorunlu Trafik Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Zorunlu trafik sigortası yaptırmak kanunen zorunludur. Bu kapsamda trafik sigortası poliçenizi Bereket Sigorta’dan yaptırabilir, üçüncü şahıslara vereceğiniz maddi ve manevi zararları güvence altına alabilirsiniz.',
          subList: null
        },
        {
          paragraph: '<strong><em><u>Ürüne Ait Teminatlar:</u></em></strong>',
          subList: [
            'Maddi Zararlar Teminatı ',
            'Sağlık Giderleri Teminatı ',
            'Sürekli Sakatlık Teminatı ',
            'Vefat Teminatı '
          ]
        },
        {
          paragraph:
            '<strong><em><u>İsteğe Bağlı Ek Teminatlar:</u></em></strong>',
          subList: ['Çekici Hizmeti']
        },
        {
          paragraph:
            'Bereket Sigorta trafik sigortası fiyatları için başvuru formunu doldurabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Araç Kasko Sigortası Nedir?',
      content: [
        {
          paragraph:
            '“Aracım Güvende Genişletilmiş Binek Kasko” poliçesi aracınızı ve bütçenizi birçok riske karşı güvence altına alır. Zorunlu trafik sigortası kapsamına girmeyen kendi aracınızı Bereket Sigorta Kasko Sigortası ile güvence altına alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Çarpma, çarpışma, yangın, hırsızlık gibi ana teminatlarının yanı sıra birçok ek teminat içeren Bereket Kasko Sigortası oldukça avantalıdır.',
          subList: null
        },
        {
          paragraph: 'İsteğe bağlı eklenebilen teminat grupları: ',
          subList: [
            'Anahtar kaybı teminatı,',
            'Asistans hizmeti/İkame araç,',
            'Deprem teminatı,',
            'Ferdi kaza teminatı,',
            'Hukuksal koruma teminatı,',
            'İhtiyari mali sorumluluk teminatı,',
            'Kemirgenlerin verebileceği zararlar teminatı,',
            'Klima teminatı,',
            'LPG teminatı,',
            'Manevi tazminat teminatı,',
            'Mini onarım hizmeti,',
            'Orijinal cam teminatı,',
            'Özel eşya teminatı,',
            'Sel ve su baskını teminatı,',
            'Ses ve görüntü teminatı,',
            'Sigara ve benzeri maddelerin sigortalı araca vereceği zararlar,',
            'Tedavi masrafları teminatı,',
            'Terör teminatı,',
            'Yanlış akaryakıt dolumu teminatı,',
            'Yurtdışı teminatı.'
          ]
        },
        {
          paragraph:
            'Olası araç risklerini hemen güvence altına alın. Bereket Kasko Sigortasının 9 taksit avantajından yararlanın.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta DASK – Zorunlu Deprem Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Bereket Sigorta DASK, zorunlu deprem sigortası ile depremin neden olabileceği maddi zararları ve deprem sonucunda meydana gelen yangın, infilak, yer kayması ve tsunami gibi hasarlara karşı evinizi güvence altına alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Zorunlu deprem sigortası hesaplamalarında poliçe primi; konutların yapı tarzı ve hangi deprem risk bölgelerine bulunduklarına göre belirlenir.',
          subList: null
        },
        {
          paragraph:
            'Hasarsız geçen her yılsonunda düzenli yenilenen poliçelerden %5, %10 ,%20 indirim kazanırsınız. ',
          subList: null
        },
        {
          paragraph:
            'Üç yıl üst üste aralıksız yenileme yapmanız durumunda da indirim oranınız % 20’ye ulaşır.',
          subList: null
        },
        {
          paragraph:
            'Hasar durumunda sigortalının alacağı sigorta bedeli, her yıl Hazine Müsteşarlığı tarafından belirlenen metrekare başına düşen inşa bedeli ile hesaplanır. ',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Konut Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Bereket Sigorta Konut Sigortasından kiracı ve mal sahipleri faydalanabilir.',
          subList: null
        },
        {
          paragraph:
            'Bereket Sigorta Konut Sigortası ile hem evinizi hem de eşyalarınızı güvence altına alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Konut Sigortası Teminatları:</u></em></strong>',
          subList: [
            'Cam Kırılması Teminatı,',
            'Dahili Su Teminatı,',
            'Deniz Taşıtları Çarpması Teminatı,',
            'Deprem Teminatı,',
            'Duman Teminatı,',
            'Enkaz Kaldırma Teminatı,',
            'Fırtına Teminatı,',
            'GLKHHKNH Ve Terör Teminatı,',
            'Hava Taşıtları Çarpması Teminatı,',
            'Hırsızlık Teminatı,',
            'Kar Ağırlığı Teminatı,',
            'Kara Taşıtları Çarpması Teminatı,',
            'Sel-Su Baskını Teminatı,',
            'Yangın Mali Mesuliyet Teminatı,',
            'Yangın, Yıldırım, İnfilak,'
          ]
        },
        {
          paragraph:
            '<strong><em><u>Konut Sigortası Ek Teminatları:</u></em></strong>',
          subList: [
            'Hukuksal Koruma Teminatı,',
            'Ferdi Kaza Teminatı,',
            'Elektronik Cihaz Teminatı,',
            'Üçüncü Şahıs Mali Sorumluluk,',
            'Makine Kırılması Teminatı.'
          ]
        }
      ]
    },
    {
      title: 'Bereket Sigorta İşyeri Sigortası Nedir?',
      content: [
        {
          paragraph:
            'İş yerinizi birçok riske karşı Bereket Sigorta güvencesine alın!',
          subList: null
        },
        {
          paragraph:
            'Olası risk durumlarına karşı teminat sunan Bereket Sigorta iş yeri sigortası ile makine, demirbaş, emtia vb. sigortalanabilir tüm değerleriniz koruma altında. Sunulan teminatların geniş kapsamlı olması ile ihtiyacınıza özel planı kolayca oluşturabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Gerekli analizlerin yapılması sonucunda sigorta uzmanlarımız sizin için en iyi teminatları ve limitleri belirleyerek poliçenizi oluşturur.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Ferdi Kaza Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Bereket Emeklilik Ferdi Kaza Sigortası kapsamında, kazadan kaynaklı vefat veya kazadan kaynaklı maluliyet risklere karşı hayat kaliteniz koruma altında.',
          subList: null
        },
        {
          paragraph:
            'Tüm bu risklere karşı ekstra planınızı oluşturmanız sizin içinde çok güvenli olacaktır. Ferdi kaza sigortasının size katkıları, yaşam kalitenizi koruyabilmek, borçlarınızı ödeyebilmek, eğitim imkanlarınızı devam ettirebilmek, gelecekteki yatırımlarınızı devam ettirebilmektir. ',
          subList: null
        },
        {
          paragraph:
            'Poliçenizi devam ettirdiğiniz zaman boyunca Vergi Avantajı sağlanır, böylece ödemelerinizin bir kısmını geri alabilme şansınız bulunur. Bu poliçenin genel anlamda şartları sigortalıyı, sigorta süresi boyunca yaşayacağı kazaların sonucuna karşı teminat altına almak, bu poliçedeki kaza, sigortalının kendini koruması dışında aniden vefat etmesi veya bedensel bir hasara maruz kalmasını karşılar.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Nakliyat Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Bereket Sigorta Nakliyat Sigortası, taşınan tüm yüklerin, onun taşınmaya uygun karayolu, denizyolu, havayolu ve demiryolu nakil için kullanılan vasıtalarla bir yerden farklı bir yere taşınması sırasında uğrayabileceği her türlü hasar ve kayıpları, poliçede belirlenmiş teminatlar, Nakliyat Sigortası Genel Şartlar ve Özel Şartlar kapsamı ile güvence altına alan sigorta ürünüdür.',
          subList: null
        },
        {
          paragraph:
            'Bereket Sigorta 5 ayrı dalda nakliyat sigortasını ayırır. Bu dallar;',
          subList: [
            'Emtea Nakliyat Sigortası',
            'Yurtiçi Taşıyıcı Sorumluluk Sigortası',
            'Yat Sigortası',
            'Tekne İnşaat Sigortası',
            'Tekne Sigortasıdır.'
          ]
        },
        {
          paragraph:
            'Bu detaylı ürünlerden faydalanmak için <strong><em><u>alokasko.com</u></em></strong> uzman sigorta danışanlarına bilgilerinizi iletmeniz durumunda, ihtiyaçlarınıza en uygun tekliflere ulaşabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Seyahat Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Bereket Seyahat Sağlık Sigortası, yolculuklarınızı güvence altına almaktadır. Seyahat süreniz boyunca kaza, yaralanma, tedavi giderleri, hastalık nedeni ile nakil, vefat eden sigortalının taşınması, kaybolan bagajların bulunması, bulunan bagajların sigortalıya ulaşımı ve yolculuk sırasında oluşabilecek tüm zorluklara karşı güvence altına alan sigorta ürünüdür. ',
          subList: null
        },
        {
          paragraph:
            'Bu ürün girişte vize koyan tüm ülkelerin, vize kontrol işlemi sırasında istedikleri zorunlu bir sigorta ürünüdür. Gidilecek ülke ve kalınacak gün sayısına bağlı olarak poliçe süresi ve poliçe primi belirlenir. Peşin ve taksitli ödeme seçenekleri mevcuttur. ',
          subList: null
        },
        {
          paragraph:
            'Seyahate çıkmadan önce <strong><em><u>alokasko.com</u></em></strong> sigorta danışmanlarına bilgi vermeniz, sizi tüm seyahat boyunca güvende tutacak poliçeye sahip olmanızı sağlayacaktır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Poliçe Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Mevcut poliçe sorgulaması için Bereket Sigorta’nın resmi web site adresini ziyaret edebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Yeni sorgulama yapmak için Bereket Sigorta ürün ihtiyaçlarınızı belirleyip <strong><em><u>alokasko.com</u></em></strong> sigorta danışmanlarına bilgi vermeniz yeterlidir. Sizin için kapsamlı, ihtiyaçlarınıza en uygun ürünü sunarak, yaşayacağınız hasar sonrasında ihtiyaç duyacağınız hizmet ve sorgulamalar sadece dakikalar içinde yapılacaktır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Hasar Dosya Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Bereket Sigorta hasar anında işlemlerinizi hızlı bir şekilde tamamlamaktadır. Yaşayacağınız hasar sonrasında sigortacınıza bilgi vermeniz durumunda sizlere gerekli desteği sağlanacaktır. ',
          subList: null
        },
        {
          paragraph:
            'Ayrıca açılan dosya sonrasında, dosya numaranız ile Bereket Sigorta resmi web sitesinden hasar dosyanızı birebir takip edebilirsiniz. ',
          subList: null
        },
        {
          paragraph:
            'Sigorta poliçenizi yapan firma <strong><em><u>alokasko.com</u></em></strong> ise sizleri yormadan hasar süreciniz takip edilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Poliçe Fiyatı Nasıl Alınır?',
      content: [
        {
          paragraph: 'Bereket Sigorta poliçe fiyatı almak bir adım uzağınızda.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>alokasko.com</u></em></strong> uzmanları talep ettiğiniz branş bazında en uygun fiyatları size sunar. Bereket Sigorta fiyatlarını değerlendirmek için başvuru formunu doldurmanız yeterlidir.',
          subList: null
        }
      ]
    }
  ]
}
